export default "__VITE_ASSET__brNFV4r___"